import { render, staticRenderFns } from "./PropertyForm.vue?vue&type=template&id=769f48ba&scoped=true&"
import script from "./PropertyForm.vue?vue&type=script&lang=js&"
export * from "./PropertyForm.vue?vue&type=script&lang=js&"
import style0 from "./PropertyForm.vue?vue&type=style&index=0&id=769f48ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769f48ba",
  null
  
)

export default component.exports